import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-two-page',
  templateUrl: './team-two-page.component.html',
  styleUrls: ['./team-two-page.component.scss']
})
export class TeamTwoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
